//# sourceMappingURL=user.mjs.map
/// <reference types="./user.d.mts" />
import * as $decrypt from "../../../data_types/decrypt.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

export class User extends $CustomType {
  constructor(name, given_name, family_name, middle_name, nickname, preferred_username, profile, picture, website, email, email_verified, gender, birthdate, zoneinfo, locale, phone_number, phone_number_verified, address, updated_at, sub, org_id) {
    super();
    this.name = name;
    this.given_name = given_name;
    this.family_name = family_name;
    this.middle_name = middle_name;
    this.nickname = nickname;
    this.preferred_username = preferred_username;
    this.profile = profile;
    this.picture = picture;
    this.website = website;
    this.email = email;
    this.email_verified = email_verified;
    this.gender = gender;
    this.birthdate = birthdate;
    this.zoneinfo = zoneinfo;
    this.locale = locale;
    this.phone_number = phone_number;
    this.phone_number_verified = phone_number_verified;
    this.address = address;
    this.updated_at = updated_at;
    this.sub = sub;
    this.org_id = org_id;
  }
}
export const User$User = (name, given_name, family_name, middle_name, nickname, preferred_username, profile, picture, website, email, email_verified, gender, birthdate, zoneinfo, locale, phone_number, phone_number_verified, address, updated_at, sub, org_id) =>
  new User(name,
  given_name,
  family_name,
  middle_name,
  nickname,
  preferred_username,
  profile,
  picture,
  website,
  email,
  email_verified,
  gender,
  birthdate,
  zoneinfo,
  locale,
  phone_number,
  phone_number_verified,
  address,
  updated_at,
  sub,
  org_id);
export const User$isUser = (value) => value instanceof User;
export const User$User$name = (value) => value.name;
export const User$User$0 = (value) => value.name;
export const User$User$given_name = (value) => value.given_name;
export const User$User$1 = (value) => value.given_name;
export const User$User$family_name = (value) => value.family_name;
export const User$User$2 = (value) => value.family_name;
export const User$User$middle_name = (value) => value.middle_name;
export const User$User$3 = (value) => value.middle_name;
export const User$User$nickname = (value) => value.nickname;
export const User$User$4 = (value) => value.nickname;
export const User$User$preferred_username = (value) => value.preferred_username;
export const User$User$5 = (value) => value.preferred_username;
export const User$User$profile = (value) => value.profile;
export const User$User$6 = (value) => value.profile;
export const User$User$picture = (value) => value.picture;
export const User$User$7 = (value) => value.picture;
export const User$User$website = (value) => value.website;
export const User$User$8 = (value) => value.website;
export const User$User$email = (value) => value.email;
export const User$User$9 = (value) => value.email;
export const User$User$email_verified = (value) => value.email_verified;
export const User$User$10 = (value) => value.email_verified;
export const User$User$gender = (value) => value.gender;
export const User$User$11 = (value) => value.gender;
export const User$User$birthdate = (value) => value.birthdate;
export const User$User$12 = (value) => value.birthdate;
export const User$User$zoneinfo = (value) => value.zoneinfo;
export const User$User$13 = (value) => value.zoneinfo;
export const User$User$locale = (value) => value.locale;
export const User$User$14 = (value) => value.locale;
export const User$User$phone_number = (value) => value.phone_number;
export const User$User$15 = (value) => value.phone_number;
export const User$User$phone_number_verified = (value) =>
  value.phone_number_verified;
export const User$User$16 = (value) => value.phone_number_verified;
export const User$User$address = (value) => value.address;
export const User$User$17 = (value) => value.address;
export const User$User$updated_at = (value) => value.updated_at;
export const User$User$18 = (value) => value.updated_at;
export const User$User$sub = (value) => value.sub;
export const User$User$19 = (value) => value.sub;
export const User$User$org_id = (value) => value.org_id;
export const User$User$20 = (value) => value.org_id;

export function decoder() {
  return $decrypt.optional_field(
    "name",
    $decode.string,
    (name) => {
      return $decrypt.optional_field(
        "given_name",
        $decode.string,
        (given_name) => {
          return $decrypt.optional_field(
            "family_name",
            $decode.string,
            (family_name) => {
              return $decrypt.optional_field(
                "middle_name",
                $decode.string,
                (middle_name) => {
                  return $decrypt.optional_field(
                    "nickname",
                    $decode.string,
                    (nickname) => {
                      return $decrypt.optional_field(
                        "preferred_username",
                        $decode.string,
                        (preferred_username) => {
                          return $decrypt.optional_field(
                            "profile",
                            $decode.string,
                            (profile) => {
                              return $decrypt.optional_field(
                                "picture",
                                $decode.string,
                                (picture) => {
                                  return $decrypt.optional_field(
                                    "website",
                                    $decode.string,
                                    (website) => {
                                      return $decrypt.optional_field(
                                        "email",
                                        $decode.string,
                                        (email) => {
                                          return $decrypt.optional_field(
                                            "email_verified",
                                            $decode.bool,
                                            (email_verified) => {
                                              return $decrypt.optional_field(
                                                "gender",
                                                $decode.string,
                                                (gender) => {
                                                  return $decrypt.optional_field(
                                                    "birthdate",
                                                    $decode.string,
                                                    (birthdate) => {
                                                      return $decrypt.optional_field(
                                                        "zoneinfo",
                                                        $decode.string,
                                                        (zoneinfo) => {
                                                          return $decrypt.optional_field(
                                                            "locale",
                                                            $decode.string,
                                                            (locale) => {
                                                              return $decrypt.optional_field(
                                                                "phone_number",
                                                                $decode.string,
                                                                (phone_number) => {
                                                                  return $decrypt.optional_field(
                                                                    "phone_number_verified",
                                                                    $decode.bool,
                                                                    (
                                                                        phone_number_verified
                                                                      ) => {
                                                                      return $decrypt.optional_field(
                                                                        "address",
                                                                        $decode.string,
                                                                        (
                                                                            address
                                                                          ) => {
                                                                          return $decrypt.optional_field(
                                                                            "updated_at",
                                                                            $decode.string,
                                                                            (
                                                                                updated_at
                                                                              ) => {
                                                                              return $decode.field(
                                                                                "sub",
                                                                                $decode.string,
                                                                                (
                                                                                    sub
                                                                                  ) => {
                                                                                  return $decrypt.optional_field(
                                                                                    "org_id",
                                                                                    $decode.string,
                                                                                    (
                                                                                        org_id
                                                                                      ) => {
                                                                                      return $decode.success(
                                                                                        new User(
                                                                                          name,
                                                                                          given_name,
                                                                                          family_name,
                                                                                          middle_name,
                                                                                          nickname,
                                                                                          preferred_username,
                                                                                          profile,
                                                                                          picture,
                                                                                          website,
                                                                                          email,
                                                                                          email_verified,
                                                                                          gender,
                                                                                          birthdate,
                                                                                          zoneinfo,
                                                                                          locale,
                                                                                          phone_number,
                                                                                          phone_number_verified,
                                                                                          address,
                                                                                          updated_at,
                                                                                          sub,
                                                                                          org_id,
                                                                                        ),
                                                                                      );
                                                                                    },
                                                                                  );
                                                                                },
                                                                              );
                                                                            },
                                                                          );
                                                                        },
                                                                      );
                                                                    },
                                                                  );
                                                                },
                                                              );
                                                            },
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function id(user) {
  return user.sub;
}

export function org_id(user) {
  return user.org_id;
}
